import { render, staticRenderFns } from "./summary.page.vue?vue&type=template&id=4cb219d9&"
import script from "./summary.page.vue?vue&type=script&lang=js&"
export * from "./summary.page.vue?vue&type=script&lang=js&"
import style0 from "./summary.page.vue?vue&type=style&index=0&id=4cb219d9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports